export const GET_VOICES_LIST_LOADING = "get/voices/list/loading"
export const GET_VOICES_LIST_SUCCESS = "get/voices/list/success"
export const GET_VOICES_LIST_ERROR = "get/voices/list/error"